import { useEnvironment } from '~/src/contexts/environment';

export function ExternalRedirect({ to }: { to: string }): null {
  const { redirectToApp } = useEnvironment();
  redirectToApp(to);

  return null;
}
